import SimpleTable from 'components/shared/table/SimpleTable';
import React from 'react';

export default function GeneralContractorsTable(props) {
  return (
    <SimpleTable
      className="general-contractor-table"
      headers={['GENERAL CONTRACTOR', 'POC', 'EMAIL'].filter(
        (header) => header
      )}
      rows={mapGeneralContractors(props.generalContractors)}
      emptyMessage="No General Contractors"
      onRowSelected={props.onRowSelected}
      onGenerateLink={props.onGenerateLink}
    />
  );
}

function mapGeneralContractors(generalContractorsData) {
  return generalContractorsData.map((generalContractor) => {
    let contact = generalContractor.contact;
    return [
      generalContractor.name,
      contact ? `${contact.first_name} ${contact.last_name}` : '',
      contact ? contact.email : '',
    ].filter((attr) => attr);
  });
}



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/GeneralContractorsTable.js